// Estimation de la fenêtre de livraison en jours ouvrés, à l'heure de la boutique.
if (!customElements.get('mp-livraison-estimee')) {
  class MpLivraisonEstimee extends HTMLElement {
    connectedCallback() {
      const texte = this.querySelector('[data-mp-livraison-texte]');
      if (!texte) return;
      texte.innerHTML = this.construireTexte();
    }

    // "+0200" -> 120
    static decalageEnMinutes(valeur) {
      const correspondance = /^([+-])(\d{2})(\d{2})$/.exec(valeur || '');
      if (!correspondance) return -new Date().getTimezoneOffset();
      const signe = correspondance[1] === '-' ? -1 : 1;
      return signe * (Number(correspondance[2]) * 60 + Number(correspondance[3]));
    }

    static estOuvre(date, samediOuvre) {
      const jour = date.getUTCDay();
      return (jour >= 1 && jour <= 5) || (samediOuvre && jour === 6);
    }

    // Avance de n jours ouvrés (n = 0 : reste sur place si le jour est ouvré, sinon prochain jour ouvré)
    static ajouterJoursOuvres(date, n, samediOuvre) {
      const resultat = new Date(date);
      while (!MpLivraisonEstimee.estOuvre(resultat, samediOuvre)) resultat.setUTCDate(resultat.getUTCDate() + 1);
      let restants = n;
      while (restants > 0) {
        resultat.setUTCDate(resultat.getUTCDate() + 1);
        if (MpLivraisonEstimee.estOuvre(resultat, samediOuvre)) restants -= 1;
      }
      return resultat;
    }

    construireTexte() {
      const d = this.dataset;
      const heureLimite = Number(d.heureLimite);
      const preparation = Number(d.preparation);
      const delaiMin = Number(d.min);
      const delaiMax = Math.max(Number(d.max), delaiMin);
      const samedi = d.samedi === 'true';

      // Heure « boutique » représentée en UTC pour éviter le fuseau du navigateur
      const maintenant = new Date(Date.now() + MpLivraisonEstimee.decalageEnMinutes(d.decalage) * 60000);
      const aujourdhui = new Date(
        Date.UTC(maintenant.getUTCFullYear(), maintenant.getUTCMonth(), maintenant.getUTCDate())
      );
      const avantLimite =
        MpLivraisonEstimee.estOuvre(aujourdhui, samedi) && maintenant.getUTCHours() < heureLimite;

      let depart = new Date(aujourdhui);
      if (!avantLimite) depart.setUTCDate(depart.getUTCDate() + 1);
      depart = MpLivraisonEstimee.ajouterJoursOuvres(depart, preparation, samedi);

      // Le transport compte du lundi au vendredi, à partir du lendemain de l'expédition
      const livraisonMin = MpLivraisonEstimee.ajouterJoursOuvres(depart, delaiMin, false);
      const livraisonMax = MpLivraisonEstimee.ajouterJoursOuvres(depart, delaiMax, false);

      const format = (date, avecMois) =>
        new Intl.DateTimeFormat('fr-FR', {
          weekday: 'short',
          day: 'numeric',
          ...(avecMois ? { month: 'short' } : {}),
          timeZone: 'UTC',
        }).format(date);

      const memeMois = livraisonMin.getUTCMonth() === livraisonMax.getUTCMonth();

      // Format court : « Chez vous entre le 25 - 26 septembre »
      if (d.court !== undefined) {
        const formatCourt = (date, avecMois) =>
          new Intl.DateTimeFormat('fr-FR', {
            day: 'numeric',
            ...(avecMois ? { month: 'long' } : {}),
            timeZone: 'UTC',
          }).format(date);
        const valeursCourtes = {
          min: formatCourt(livraisonMin, !memeMois),
          max: formatCourt(livraisonMax, true),
          jour: formatCourt(livraisonMin, true),
        };
        const modeleCourt =
          livraisonMin.getTime() === livraisonMax.getTime() ? d.modeleCourtJour : d.modeleCourt;
        return modeleCourt.replace(/\[(min|max|jour)\]/g, (_, cle) => valeursCourtes[cle]);
      }

      const gras = (valeur) => `<strong>${valeur}</strong>`;
      const valeurs = {
        heure: `${heureLimite}h`,
        min: gras(format(livraisonMin, !memeMois)),
        max: gras(format(livraisonMax, true)),
        jour: gras(format(livraisonMin, true)),
      };

      let modele;
      if (livraisonMin.getTime() === livraisonMax.getTime()) modele = d.modeleJour;
      else modele = avantLimite ? d.modeleAvant : d.modeleApres;

      return modele.replace(/\[(heure|min|max|jour)\]/g, (_, cle) => valeurs[cle]);
    }
  }

  customElements.define('mp-livraison-estimee', MpLivraisonEstimee);
}
